import { create } from 'zustand';

interface ExpensesListState {
  // Pagination
  page: number;
  limit: number;

  // Filters
  search: string;
  category: string;

  // Column visibility
  visibleColumns: string[];
}

interface ExpensesListActions {
  // Pagination actions
  setPage: (page: number) => void;
  setLimit: (limit: number) => void;

  // Filter actions
  setSearch: (search: string) => void;
  setCategory: (category: string) => void;

  // Column actions
  toggleColumn: (column: string) => void;

  // Utility actions
  resetFilters: () => void;
  resetAll: () => void;
}

type ExpensesListStore = ExpensesListState & ExpensesListActions;

export const DEFAULT_EXPENSE_COLUMNS = [
  'entity', 'date', 'category', 'vendor', 'description', 'paymentMethod', 'amount',
];

const initialState: ExpensesListState = {
  page: 1,
  limit: 100,
  search: '',
  category: 'all',
  visibleColumns: DEFAULT_EXPENSE_COLUMNS,
};

export const useExpensesListStore = create<ExpensesListStore>()((set) => ({
  ...initialState,

  // Pagination actions
  setPage: (page) => set({ page }),
  setLimit: (limit) => set({ limit, page: 1 }),

  // Filter actions
  setSearch: (search) => set({ search, page: 1 }),
  setCategory: (category) => set({ category, page: 1 }),

  // Column actions
  toggleColumn: (column) =>
    set((state) => ({
      visibleColumns: state.visibleColumns.includes(column)
        ? state.visibleColumns.filter((c) => c !== column)
        : [...state.visibleColumns, column],
    })),

  // Utility actions
  resetFilters: () => set({ search: '', category: 'all', page: 1 }),
  resetAll: () => set(initialState),
}));
